<script>
    import FileExtensionIcon from "./fileExtensionIcon"
    import ClienteFileContext from "./context-menu/cliente-file-context"
    import {downloadArquivo, deleteArquivo} from "@/domain/gerencia/clientes/services"
    import {humanStorageSize} from "uloc-vue/src/utils/format"
    export default {
      name: 'cliente-file',
      props: {
        file: {required: false},
        h: {required: false},
        cliente: {required: false}
      },
      data () {
        return {}
      },
      computed: {},
      mounted () {
        this.$nextTick(() => {
        })
      },
      destroyed () {
      },
      methods: {
        download(arquivo, inline = false) {
          arquivo.downloading = true
          let method = (a, b) => downloadArquivo({id: this.cliente ? this.cliente.id : this.h.entityId}, a, b, this.isGerencia)
          method(arquivo.id, inline)
              .then(response => {
                console.log(response.data)
                const link = document.createElement('a')
                link.href = response.data.url
                link.target = '_blank'
                document.body.appendChild(link)
                link.click();
                window.setTimeout(() => {
                  document.body.removeChild(link)
                  arquivo.downloading = false
                }, 100)
                // window.open(response.data.url)
              })
              .catch(error => {
                arquivo.downloading = false
                this.alertApiError(error)
              })
        },
        filesize (size) {
          return humanStorageSize(size)
        },
        confirmaExcluir (file) {
          this.$uloc.dialog({
            title: 'Atenção',
            message: `Tem certeza que deseja excluir o arquivo ${file.originalFilename}?`,
            cancel: true,
            color: 'secondary'
          }).then(data => {
            this.$uloc.notify({color: 'warning', message: 'Excluindo mensagem'})
            this.excluir(file)
          }).catch(() => {
          })
        },
        excluir (file) {
          if (!file) return
          deleteArquivo({id: this.cliente?.id || this.h.entityId}, file.id)
              .then(response => {
                console.log(response)
                this.$el.style.display = 'none'
                this.$uloc.notify({color: 'positive', message: 'Mensagem excluída!'})
                this.$emit('updateHistory')
              })
              .catch(error => {
                this.alertApiError(error)
              })
        }
      },
      components: {ClienteFileContext, FileExtensionIcon}
    }
</script>

<template>
    <a @click="download(file, true)" class="file">
        <file-extension-icon ref="extension" :extension="file.extension"/>
        <span ref="name" class="fileName">{{file.originalFilename}}</span>
        <span ref="size" class="fileSize">{{filesize(file.size)}}</span>
        <cliente-file-context @download="download(file)" @preview="download(file, true)" @remove="confirmaExcluir(file)" :h="h" :file="file"/>
    </a>
</template>
